export const CONSTANTS = {
    STATE: {
        TYPING_BODY: "TYPING_BODY",
        WAITING_FOR_RESPONSE: "WAITING_FOR_RESPONSE",
        TYPING_RESPONSE: "TYPING_RESPONSE",
        COMPLETE: "COMPLETE"
    },
    ATTACHED_COMPONENTS: {
        NOTE_FOR_COMPUTER_NERDS: "NOTE_FOR_COMPUTER_NERDS",
    }

};
